import React, { useState } from 'react';
import ReceivableDebtTab from './ReceivableReport/ReceivableDebtTab';
import ReconciliationTab from './ReceivableReport/ReconciliationTab';
import StatisticsTab from './ReceivableReport/StatisticsTab';

type TabId = 'debt' | 'statistics' | 'reconciliation';

const TABS: { id: TabId; label: string }[] = [
  { id: 'debt', label: 'Công nợ' },
  { id: 'statistics', label: 'Thống kê' },
  { id: 'reconciliation', label: 'Đối soát' },
];

export const ReceivableReport: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabId>('debt');
  const [detailSheetFullscreen, setDetailSheetFullscreen] = useState(false);

  return (
    <div className="max-w-7xl mx-auto p-6">
      <nav className="flex mb-6 text-sm">
        <span className="text-gray-500">🏠</span>
        <span className="mx-2 text-gray-400">/</span>
        <span className="text-gray-500">PHÍ DỊCH VỤ</span>
        <span className="mx-2 text-gray-400">/</span>
        <span className="text-gray-500">Báo cáo</span>
        <span className="mx-2 text-gray-400">/</span>
        <span className="text-cyan-600 font-medium">Phí phải thu</span>
      </nav>

      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Báo cáo phí phải thu</h1>
        <p className="text-sm text-gray-500">
          Theo dõi công nợ phí dịch vụ theo căn hộ, thanh toán nhanh và xuất báo cáo.
        </p>
      </div>

      {!detailSheetFullscreen && (
        <div className="border-b border-gray-200 mb-6">
          <div className="flex gap-1">
            {TABS.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-5 py-3 text-sm font-medium border-b-2 transition-colors ${
                  activeTab === tab.id
                    ? 'border-cyan-600 text-cyan-700'
                    : 'border-transparent text-gray-600 hover:text-gray-900 hover:border-gray-300'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      )}

      {activeTab === 'debt' && <ReceivableDebtTab />}
      {activeTab === 'statistics' && (
        <StatisticsTab onDetailSheetFullscreenChange={setDetailSheetFullscreen} />
      )}
      {activeTab === 'reconciliation' && <ReconciliationTab />}
    </div>
  );
};
